import styled from 'styled-components';

import { thumbnailOverflowWrapper } from '@pkg/components/Thumbnail/tokens';
import {
    floorGameDuration as duration,
    floorGameEasing as easing,
    styledInteraction,
    styledLayout,
    styledReset,
} from '@pkg/primitives';

import { tokens } from '../../tokens';

export const NftAssetStatic = styled.div`
    border-radius: ${tokens.nftAsset.radius}px;
`;

export const NftAssetButton = styled.button.attrs({ type: 'button' })`
    ${styledReset.button};
    --yat_nft-card-asset-glow-opacity: 0;

    position: relative;
    z-index: ${tokens.zindex.content};
    display: block;
    width: 100%;
    border-radius: ${tokens.nftAsset.radius}px;

    &::before {
        ${styledLayout.positionCover({
            offset: -(tokens.nftAsset.borderWidth * 2),
        })};
        content: '';
        background-color: rgba(255, 255, 255, 0.1);
        border-radius: ${tokens.nftAsset.radius * 2}px;
        opacity: var(--yat_nft-card-asset-glow-opacity);
        transition: opacity ${duration.normal}ms ${easing.cubic};
    }

    ${styledInteraction.focusRing({
        width: tokens.nftAsset.borderWidth,
        offset: -(tokens.nftAsset.borderWidth * 2),
        radius: tokens.nftAsset.radius * 2,
        pseudoAfter: true,
    })};

    &:hover {
        --yat_nft-card-asset-glow-opacity: 1;
    }

    &:active {
        --yat_nft-card-asset-glow-opacity: 0.6;
    }
`;

export const ThumnailWrapper = styled.div`
    ${thumbnailOverflowWrapper(tokens.nftAsset.radius)};
    z-index: ${tokens.zindex.content + 1};
    aspect-ratio: 1 / 1;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.4);
`;
